import { rowsToObjects, runQuery as runAnalyticsQuery } from "./analyticsClient.js";

// Resolve a declarative table-detail query against one parent row. `$row`
// markers are values, never identifiers, and the analytics planner binds them
// as ClickHouse parameters after type validation.
export function bindTableDetailRow(node, row, insideValue = false) {
    if (node == null) return node;
    if (Array.isArray(node)) {
        return node.map((value) => bindTableDetailRow(value, row, insideValue));
    }
    if (typeof node !== "object") return node;
    if (Object.keys(node).length === 1 && typeof node.$row === "string") {
        if (!insideValue) {
            throw new Error("Detail query row markers are allowed only inside predicate values");
        }
        const value = row?.[node.$row];
        if (value === undefined || value === null || value === "") {
            throw new Error(`Detail query row field ${node.$row} is missing`);
        }
        return value;
    }
    return Object.fromEntries(
        Object.entries(node).map(([key, value]) => [
            key,
            bindTableDetailRow(value, row, insideValue || key === "value"),
        ]),
    );
}

export async function loadKernelTableDetail(detailQuery, row, { signal } = {}) {
    if (!detailQuery?.spec || typeof detailQuery.spec !== "object") {
        throw new Error("Table detail query is missing its analytics spec");
    }
    const spec = bindTableDetailRow(detailQuery.spec, row);
    return rowsToObjects(await runAnalyticsQuery(spec, { cache: false, signal }));
}
